// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2RzAl","title":"AfterFrontImage_title__xlA_5"};